import { PlayerManager } from './PlayerManager';
import { EventBus } from './EventBus';
import { store } from '../store/store';

class Timer {
  constructor() {
    if (!Timer.instance) {
      this.oldTime = 0;
      this.position = 0;
      this.interval = null;
      Timer.instance = this;
    }
  }

  start() {
    if (this.interval) {
      return;
    }
    // custom approach
    this.interval = setInterval(function () {
      var position = 0
      try {
        position = PlayerManager.nativeHtml5VideoNode.currentTime
        if (position === 0) {
          // fall back to playermanager on a zero value (IOS)
          position = PlayerManager.getPosition();
        }
      } catch (e) { }

      var time = Math.round((position + Number.EPSILON) * 10) / 10
      if (time !== this.oldTime) {
        store.commit('changeTime', time);
        EventBus.$emit('timeChange', time);
        this.oldTime = time
      }
    }, 50)
  }

  stop() {
    if (this.interval) {
      clearInterval(this.interval)
      this.interval = null;
    }
  }
}

export const timer = new Timer();
